export function isProviderFirstLocale(locale) {
    return locale === 'tr';
}
export function formatPlayByProvider(play, gameName, byLabel, providerName, locale) {
    if (isProviderFirstLocale(locale)) {
        return `${play} ${gameName} ${providerName} ${byLabel}`;
    }
    return `${play} ${gameName} ${byLabel} ${providerName}`;
}
